import React from "react";

import TextInput from "../../../../components/formElements/input/TextInput";
import Row from "../../../../components/uiElements/grid/Row";
import Col from "../../../../components/uiElements/grid/Col";
import Card from "../../../../layout/Onboarding/Card";
import Lable from "../../../../components/formElements/label/Label";
import CardLable from "../../../../components/formElements/label/CardLabel";

export const MedicalConditionCard = ({
  addMedicalCondition,
  removeMedicalCondition,
  personalPatientInfo,
  setPatientPersonalInfo,
  form,
}) => {
  return (
    <Card>
      <Row className="mt-4 mb-4">
        <Col>
          <CardLable
            name="Medical Condition"
            condition={personalPatientInfo.current_medical_condition}
            onclick={() => addMedicalCondition()}
            labelName={
              personalPatientInfo.current_medical_condition ? "Add" : ""
            }
          />
        </Col>
        <Col className="mt-3 mb-n4">
          <TextInput
            id="current_medical_condition"
            type="text"
            // error={form.medical_condition}
            label="Medical Condition"
            value={personalPatientInfo.current_medical_condition}
            onChange={val =>
              setPatientPersonalInfo({ current_medical_condition: val })
            }
          />
        </Col>
        {personalPatientInfo.medical_condition !== null
          ? personalPatientInfo.medical_condition.map((value, index) => (
              <Col className="mt-n1 mb-4">
                <Lable
                  name="medical-condition"
                  onclick={() => removeMedicalCondition(index)}
                  value={value}
                />
              </Col>
            ))
          : ""}
      </Row>
    </Card>
  );
};
